export default "__VITE_ASSET__k$_eGFky__"